import { createSlice } from "@reduxjs/toolkit";

interface RootState {
  authToken: string;
  hrprofile_admin: boolean;
  hrprofile_inspect: boolean;
  opus_admin: boolean;
  user_details: Record<string, any>;
  module_details: Record<string, any>;
  company_details: Record<string, any>;
  privilege_details: Record<string, any>;
}
const initialState: RootState = {
  authToken: '',
  hrprofile_admin: false,
  hrprofile_inspect: false,
  opus_admin: false,
  user_details: {},
  module_details: {},
  company_details: {},
  privilege_details: {},

};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthDetails: (state, { payload }) => {
      state.opus_admin = payload.opus_admin;
      state.hrprofile_admin = payload.hrprofile_admin;
      state.hrprofile_inspect = payload.hrprofile_inspect;
      state.user_details = payload.user_details;
      state.module_details = payload.module_details;
      state.company_details = payload.company_details;
      state.privilege_details = payload.privilege_details;
    },
    setAuthToken: (state, { payload }) => {
      state.authToken = payload;
    },
    setUserDetails: (state, { payload }) => {
      state.user_details = payload;
    },
    setModuleDetails: (state, { payload }) => {
      state.module_details = payload;
    },
    setCompanyDetails: (state, { payload }) => {
      state.company_details = payload;
    },
    setPrivilageDetails: (state, { payload }) => {
      state.privilege_details = payload;
    },
    resetAuthSlice: () => initialState,
  },
});

export const { setAuthDetails, setAuthToken, setUserDetails, setModuleDetails, setCompanyDetails, setPrivilageDetails, resetAuthSlice } = authSlice.actions;

export const getAuthToken = (state: any) => state.authReducer.authToken;
export const isHrAdmin = (state: any) => state.authReducer.hrprofile_admin;
export const isHrInspect = (state: any) => state.authReducer.hrprofile_inspect;
export const isOpusAdmin = (state: any) => state.authReducer.opus_admin;
export const getUserDetails = (state: any) => state.authReducer.user_details;
export const getModuleDetails = (state: any) => state.authReducer.module_details;
export const getCompanyDetails = (state: any) => state.authReducer.company_details;
export const getPrivilageDetails = (state: any) => state.authReducer.privilege_details;

export default authSlice.reducer;
